enum StatusContas {
    Aberto = 0,
    ParcialmenteLiquidado = 1,
    Liquidado = 2
}

export default StatusContas;